var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 62,
    viewBox: "0 0 43 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7712 21.0013C10.7712 17.4394 6.25299 16.4953 5.05429 19.8281C2.15471 27.8899 0.0419922 35.1018 0.0419922 39.001C0.0419922 51.4274 9.64922 61.501 21.5003 61.501C33.3514 61.501 42.9587 51.4274 42.9587 39.001C42.9587 34.8119 40.52 26.799 37.287 18.0164C33.0989 6.63955 31.0048 0.951111 28.4199 0.644718C27.5928 0.546678 26.6904 0.722944 25.9525 1.12672C23.6462 2.38857 23.6462 8.59281 23.6462 21.0013C23.6462 24.7292 20.764 27.7513 17.2087 27.7513C13.6533 27.7513 10.7712 24.7292 10.7712 21.0013Z",
    fill: "#F87CE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/fireIcon.e9e6c7abd4ef12d365e2bb970600c212.svg";
export { ForwardRef as ReactComponent };